import React from "react"
import { NavLink } from "react-router-dom"
import AccountBalance from "@mui/icons-material/AccountBalance"
import EventIcon from "@mui/icons-material/Event"
import HomeIcon from "@mui/icons-material/Home"
import Newspaper from "@mui/icons-material/Newspaper"
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism"
import { useTheme } from "@mui/material"
import BottomNavigation from "@mui/material/BottomNavigation"
import BottomNavigationAction from "@mui/material/BottomNavigationAction"
import Paper from "@mui/material/Paper"

const styles = (theme) => ({
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
  },
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
})
const BottomNavbar = (): JSX.Element => {
  const pathMap = [
    {
      icon: <HomeIcon />,
      label: "Home",
      pathname: "/home",
      visible: true,
    },
    {
      icon: <VolunteerActivismIcon />,
      label: "Donate",
      pathname: "/options",
      visible: true,
    },
    {
      icon: <EventIcon />,
      label: "Events",
      pathname: "/events",
      visible: true,
    },
    {
      icon: <Newspaper />,
      label: "Newsletter",
      pathname: "/newsletter",
      visible: true,
    },
    {
      icon: <AccountBalance />,
      label: "Financials",
      pathname: "/financials",
      visible: true,
    },
  ]

  const theme = useTheme()
  return (
    <BottomNavigation
      showLabels
      component={Paper}
      elevation={3}
      sx={styles(theme)}
    >
      {pathMap
        .filter((item: any) => item.visible)
        .map((item) => (
          <BottomNavigationAction
            key={item.pathname}
            component={NavLink}
            icon={item.icon}
            label={item.label}
            sx={{
              "&.active": {
                color: "action.selected",
              },
              //  display: item.visible ? "block" : "none",
            }}
            to={item.pathname}
          />
        ))}
    </BottomNavigation>
  )
}
export default BottomNavbar
